export default "__VITE_ASSET__D5SgPS2j__"